import { Editor } from "grapesjs";

export default (editor: Editor) => {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;

  domComponents.addType("heading", {
    extend: "text",
    model: {
      defaults: {
        tagName: "h1",
        droppable: false,
        editable: true,
        traits: [
          {
            type: "select",
            label: "Heading Size",
            name: "tagName",
            options: [
              { value: "h1", id: "h1", name: "H1" },
              { value: "h2", id: "h2", name: "H2" },
              { value: "h3", id: "h3", name: "H3" },
              { value: "h4", id: "h4", name: "H4" },
              { value: "h5", id: "h5", name: "H5" },
              { value: "h6", id: "h6", name: "H6" },
            ],
            changeProp: true, // Trigger update on change
          },
        ],
        init() {
          this.on("change:tagName", this.updateTagName);
        },
        updateTagName() {
          const newTagName = this.get("tagName");
          this.replaceWith(this.clone().set({ tagName: newTagName }));
        },
      },
      },
  });


  // Add the block to the block manager
  blockManager.add("heading-block", {
    label: "Heading",
    category: "Basic",
    media: `<i class="fa-sharp fa-light fa-heading fs-2"></i>`,
    content: {
      type: "heading",
      content: "Double-click to edit me!",
    },
  });
};
